import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { HelpersService } from 'src/app/helpers.service'
import { BuilderService } from '../../builder-services/builder.service'
import { timeout } from 'rxjs/operators'
import { AppSettingsService } from 'src/app/settings/services/app-settings.service'
import { LoginService } from '../../login/login.service'
import { AnalyticsApiService } from 'src/app/builder-services/api/analytics.api.service'

@Injectable({
  providedIn: 'root'
})
export class AndroidbuildService {
  buildingAndroid = false

  private builderUrl: string

  options = {
    headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
  }
  token: any

  constructor(private http: HttpClient, private helper: HelpersService, private builderService: BuilderService, private appSettings: AppSettingsService, private loginService: LoginService, private analyticsApi: AnalyticsApiService) {
    this.builderUrl = this.helper.getBuilderUrl()
    this.token = this.builderService.getToken()
    this.buildingAndroid = true
  }

  startBuild = (id: any, version: any, versionCode: any, type: string = '', timeout_val: number = 0) => {
    this.token = this.builderService.getToken()
    let postData = new URLSearchParams()
    postData.set('process', 'sync_ui')
    postData.set('projectId', id)
    postData.set('standalone', this.builderService.standalone ? 'true' : 'false')
    postData.set('type', type)
    postData.set('version', JSON.stringify(version))
    postData.set('versionCode', JSON.stringify(versionCode))
    postData.set('token', this.token)

    // Track Android build analytics (skip if user is admin)
    this.trackAndroidBuild(id)

    if (timeout_val !== 0) {
      return this.http.post(this.builderUrl + 'build-android', postData.toString(), this.options).pipe(timeout(timeout_val))
    } else {
      return this.http.post(this.builderUrl + 'build-android', postData.toString(), this.options)
    }
  }

  getProgress = (id: any, version: any) => {
    this.token = this.builderService.getToken()
    let postData = new URLSearchParams()
    postData.set('process', 'sync_ui')
    postData.set('projectId', id)
    postData.set('version', JSON.stringify(version))
    postData.set('type', 'android_status')
    postData.set('token', this.token)

    return this.http.post(this.builderUrl + 'get-build-progress', postData.toString(), this.options)
  }

  getBuildError = (id: any) => {
    this.token = this.builderService.getToken()
    let postData = new URLSearchParams()
    postData.set('projectId', id)
    postData.set('token', this.token)
    postData.set('platform', 'android')

    return this.http.post(this.builderUrl + 'get-build-error', postData.toString(), this.options)
  }

  getAppVersions(packageName: string) {
    const url = `${this.builderUrl}get-app-versions?packageName=${packageName}`
    return this.http.get(url)
  }

  /**
   * Check if app is published on Google Play
   */
  checkAppPublished(packageName: string) {
    const url = `${this.builderUrl}check-app-published?packageName=${packageName}`
    return this.http.get<{ isPublished: boolean; productionStatus: string | null; packageName: string; error?: string }>(url)
  }

  numericVersionForApi(versionName: string, versionCode: number): number {
    return /^\d+$/.test(String(versionName)) ? Number(versionName) : Number(versionCode)
  }

    /**
   * Uploads AAB to Google Play and submits for review
   */
  uploadToGooglePlay = (packageName: string, projectId: string, versionCode: number, versionName: string, whatsNew: string, track: string = 'production') => {
    this.token = this.builderService.getToken()
    let postData = new URLSearchParams()
    postData.set('token', this.token)
    postData.set('packageName', packageName)
    postData.set('projectId', projectId)
    postData.set('versionCode', JSON.stringify(versionCode))
    postData.set('versionName', versionName)
    postData.set('whatsNew', whatsNew)
    postData.set('track', track)

    return this.http.post(this.builderUrl + 'upload-to-google-play', postData.toString(), this.options)
  }
  
  /**
   * Tracks Android build analytics via the stacks-agents creation layer.
   * Skips tracking if the current user is an admin.
   */
  private trackAndroidBuild(projectId: string): void {
    if (this.loginService.getCurrentUser()?.admin) return
    this.analyticsApi.trackBuild(String(projectId), 'android')
      .catch((error) => console.error('Error tracking Android build analytics:', error))
  }
}
